import React from "react";
import img from "../../../../../assets/images/journal/j-indicator-sample.jpg"

const SAchievement = (parent) => {
    const record = parent.record;
    // record.error_code
    return (
        <div className="mt-65">
            <div className="d-flex justify-content-between align-items-center mb-px-26">
                <div className="d-flex align-items-center">
                    <h3 className="con-title">Research Achievement</h3>
                </div>
            </div>
            {record.error_code ?
                <img src={img} style={{ width: "100%" }} />
                :
                <div>
                    <table className="table table-lightgray">
                        <colgroup>
                            <col width="19%" />
                            <col width="11%" />
                            <col width="11%" />
                            <col width="14%" />
                            <col width="9%" />
                            <col width="9%" />
                            <col width="9%" />
                            <col width="9%" />
                            <col width="9%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col" className=""></th>
                                <th scope="col" className="">발행논문</th>
                                <th scope="col" className="">Avg · Citation</th>
                                <th scope="col" className="">발행논문<br />In Top 10 Jounal</th>
                                <th scope="col" className="">단독저자</th>
                                <th scope="col" className="">국제공동</th>
                                <th scope="col" className="">SCI</th>
                                <th scope="col" className="">Scopus</th>
                                <th scope="col" className="">KCI</th>
                            </tr>
                        </thead>
                        <tbody>
                            {record.research_all_achievement &&
                                <tr>
                                    <td className="text-left">All (09~21)</td>
                                    <td className="">{record.research_all_achievement.resource_count}</td>
                                    <td className="">{record.research_all_achievement.avg_citation}</td>
                                    <td className="">{record.research_all_achievement.in_top10_journal}</td>
                                    <td className="">{record.research_all_achievement.sole_author_count}</td>
                                    <td className="">{record.research_all_achievement.international_count}</td>
                                    <td className="">{record.research_all_achievement.SCI}</td>
                                    <td className="">{record.research_all_achievement.Scopus}</td>
                                    <td className="">{record.research_all_achievement.KCI}</td>
                                </tr>
                            }
                            {record.research_last5year_achievement &&
                                <tr>
                                    <td className="text-left">5 Year</td>
                                    <td className="">{record.research_last5year_achievement.resource_count}</td>
                                    <td className="">{record.research_last5year_achievement.avg_citation}</td>
                                    <td className="">{record.research_last5year_achievement.in_top10_journal}</td>
                                    <td className="">{record.research_last5year_achievement.sole_author_count}</td>
                                    <td className="">{record.research_last5year_achievement.international_count}</td>
                                    <td className="">{record.research_last5year_achievement.SCI}</td>
                                    <td className="">{record.research_last5year_achievement.Scopus}</td>
                                    <td className="">{record.research_last5year_achievement.KCI}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
};

export default SAchievement;
